// Textos da área do afiliado (/{idioma}/afiliado). São os do template Manus, com
// "parceiro(s)" trocado por "afiliado(s)" e "afiliada" por "afiliado". Os marcados
// com "novo" não existem no template e estão na lista de revisão do Thiago (plano,
// §4.4). O inglês é tradução nossa, também para revisão.

const areaafiliado = {
  portugues: {
    seo: {
      titulo: "Área do afiliado",
      descricao: "Acompanhe seus acessos, vendas e comissões no Programa de Afiliados do Bella da Semana.",
    },
    login: {
      areaSegura: "Área segura do afiliado",
      eyebrow: "Clube de afiliados Bella",
      titulo: "Seu próximo resultado",
      tituloDestaque: "começa aqui.",
      lede: "Acompanhe sua audiência, organize seus links e transforme cada indicação em uma nova história de sucesso.",
      kicker: "Portal de afiliados",
      entrarNaConta: "Entre na sua conta",
      copy: "Acesse seus indicadores, materiais e links personalizados.",
      email: "E-mail",
      emailPlaceholder: "voce@email.com",
      senha: "Senha",
      esqueci: "Esqueci minha senha",
      entrar: "Entrar no portal",
      ou: "ou",
      naoSouAfiliado: "Ainda não sou afiliado",
      nota: "Ao continuar, você concorda com os termos do programa de afiliados.",
      // novo
      camposObrigatorios: "Informe o e-mail e a senha.",
    },
    shell: {
      areaDoAfiliado: "Área do afiliado",
      visaoGeral: "Visão geral",
      meusLinks: "Meus links",
      materialDeApoio: "Material de apoio",
      codigo: "Código",
      sair: "Sair da conta",
      // novo
      abrirMenu: "Abrir menu",
      fecharMenu: "Fechar menu",
    },
    painel: {
      eyebrow: "Visão geral",
      ola: "Olá, {nome}.",
      descricao: "Aqui está o resumo da sua performance como afiliado.",
      filtros: "Filtros",
      todasAssinaturas: "Todas as assinaturas",
      limparFiltros: "Limpar filtros",
      acessos: "Acessos no link",
      compras: "Compras",
      renovacoes: "Renovações",
      totalVendas: "Total em vendas",
      cadastros: "Cadastros",
      vsAnterior: "vs. período anterior",
      performance: "Performance financeira",
      comissoesPorSemana: "Comissões por semana",
      comissaoGerada: "Comissão gerada",
      graficoAria: "Gráfico de comissões por semana",
      acimaDaMedia: "Você está acima da média.",
      conversaoCresceu: "Sua conversão cresceu {percentual} neste período. Continue compartilhando seus links de modelos.",
      receitaPorProduto: "Receita por produto",
      maisConvertem: "Assinaturas que mais convertem",
      verLinks: "Ver links",
      plano: "Plano",
      vendas: "Vendas",
      conversao: "Conversão",
      comissao: "Comissão",
      // novo
      semVendas: "Nenhuma venda no período.",
      atalhos: "Atalhos rápidos",
      proximoCompartilhamento: "Pronto para o próximo compartilhamento?",
      atalhosCopy: "Tenha seus principais recursos sempre à mão.",
      copiarMeuLink: "Copiar meu link",
      copiarMeuLinkCopy: "Compartilhe seu código único",
      materiais: "Materiais da semana",
      materiaisCopy: "Veja as novas fotos e peças",
      suporte: "Falar com suporte",
      suporteCopy: "Estamos aqui para ajudar",
    },
    periodos: {
      1: "mensal",
      3: "trimestral",
      // novo
      6: "semestral",
      12: "anual",
    } as Record<number, string>,
    periodosTitulo: {
      1: "Mensal",
      3: "Trimestral",
      6: "Semestral",
      12: "Anual",
    } as Record<number, string>,
    comissoes: {
      proxima: "Próxima comissão",
      cicloAtual: "Ciclo atual",
      concluido: "{percentual}% concluído",
      // novo (singular)
      vendaElegivel: "1 venda elegível",
      vendasElegiveis: "{quantidade} vendas elegíveis",
      verDetalhes: "Ver detalhes",
      ultimosRepasses: "Últimos repasses",
      historico: "Histórico de comissões",
      pago: "Pago",
      // novo
      emAberto: "Em aberto",
      verHistorico: "Ver histórico completo",
      // novo
      semComissoes: "Nenhuma comissão ainda.",
    },
    links: {
      eyebrow: "Ativação",
      titulo: "Meus links",
      descricao: "Cada link já carrega seu código de afiliado. É só copiar e compartilhar.",
      criar: "Criar link personalizado",
      seuCodigo: "Seu código de afiliado: {codigo}",
      calloutCopy: "Use qualquer link abaixo para acompanhar os resultados da sua divulgação.",
      copiarCodigo: "Copiar código",
      copiado: "Copiado",
      modelosDisponiveis: "Modelos disponíveis",
      porModelo: "Links por modelo",
      buscar: "Buscar modelo",
      ensaioMakingOf: "Ensaio + making of",
      ensaioExclusivo: "Ensaio exclusivo",
      ativo: "Ativo",
      copiar: "Copiar",
      escolhaModelo: "Escolha a modelo",
      selecioneModelo: "Selecione uma modelo",
      linkUniversal: "Link universal",
      leveAssinantes: "Leve novos assinantes para o Bella da Semana.",
      bannerCopy: "Use sua página de assine para apresentar todos os planos em um só lugar.",
      copiarAssine: "Copiar link da página de assine",
    },
    material: {
      eyebrow: "Biblioteca de divulgação",
      titulo: "Material de apoio",
      descricao: "Fotos e vídeos sempre sem nudez, prontos para divulgar o Bella da Semana.",
      destaqueDaSemana: "Destaque da semana",
      novaBella: "{modelo} é a nossa nova Bella da Semana.",
      destaqueCopy: "Baixe fotos e vídeos curtos para o seu feed, stories e grupos.",
      baixarPacote: "Baixar pacote completo",
      marca: "BELLA DA SEMANA",
      editorial: "EDITORIAL",
      nota: "Conteúdo seguro para divulgação: fotos e vídeos sem nudez.",
      semana: "Semana {numero}",
      tipos: {
        fotos_verticais: "Fotos verticais",
        fotos_video: "Fotos + vídeo",
        fotos_feed: "Fotos para feed",
      } as Record<string, string>,
      fotos: "fotos",
      // novo (singular)
      foto: "foto",
      atualizadoOntem: "Atualizado ontem",
      // novo
      atualizadoHoje: "Atualizado hoje",
      acervo: "Acervo da Bella",
      modeloAntiga: "Precisa de material de uma modelo mais antiga?",
      modeloAntigaCopy: "Solicite fotos ou vídeos de modelos anteriores do site. A equipe verifica o acervo e envia o pacote disponível para divulgação.",
      escolhaModelo: "Escolha a modelo",
      selecioneModelo: "Selecione uma modelo",
      outraModelo: "Outra modelo",
      digiteNome: "Digite o nome da modelo",
      nomeDaModelo: "Nome da modelo",
      solicitar: "Solicitar material",
      solicitacaoEnviada: "Solicitação enviada",
      // novos
      baixarDe: "Baixar o pacote de {modelo}",
      semMaterial: "Nenhum pacote publicado ainda. Os materiais da semana aparecem aqui.",
    },
    mensagens: {
      erro: "Erro",
      fechar: "Fechar",
      // novos
      muitasTentativas: "Muitas tentativas. Aguarde um minuto e tente de novo.",
      falhaAoCarregar: "Não foi possível carregar os dados. Tente de novo em instantes.",
    },
  },
  ingles: {
    seo: {
      titulo: "Affiliate Area",
      descricao: "Track your visits, sales and commissions in the Bella Club Affiliate Program.",
    },
    login: {
      areaSegura: "Secure affiliate area",
      eyebrow: "Bella affiliate club",
      titulo: "Your next result",
      tituloDestaque: "starts here.",
      lede: "Follow your audience, organize your links and turn every referral into a new success story.",
      kicker: "Affiliate portal",
      entrarNaConta: "Sign in to your account",
      copy: "Access your metrics, materials and custom links.",
      email: "Email",
      emailPlaceholder: "you@email.com",
      senha: "Password",
      esqueci: "Forgot my password",
      entrar: "Sign in to the portal",
      ou: "or",
      naoSouAfiliado: "I'm not an affiliate yet",
      nota: "By continuing, you agree to the affiliate program terms.",
      camposObrigatorios: "Enter your email and password.",
    },
    shell: {
      areaDoAfiliado: "Affiliate Area",
      visaoGeral: "Overview",
      meusLinks: "My links",
      materialDeApoio: "Marketing materials",
      codigo: "Code",
      sair: "Sign out",
      abrirMenu: "Open menu",
      fecharMenu: "Close menu",
    },
    painel: {
      eyebrow: "Overview",
      ola: "Hello, {nome}.",
      descricao: "Here is a summary of your performance as an affiliate.",
      filtros: "Filters",
      todasAssinaturas: "All subscriptions",
      limparFiltros: "Clear filters",
      acessos: "Link visits",
      compras: "Purchases",
      renovacoes: "Renewals",
      totalVendas: "Total sales",
      cadastros: "Sign-ups",
      vsAnterior: "vs. previous period",
      performance: "Financial performance",
      comissoesPorSemana: "Commissions per week",
      comissaoGerada: "Commission earned",
      graficoAria: "Chart of commissions per week",
      acimaDaMedia: "You are above average.",
      conversaoCresceu: "Your conversion grew {percentual} in this period. Keep sharing your model links.",
      receitaPorProduto: "Revenue by product",
      maisConvertem: "Top converting subscriptions",
      verLinks: "See links",
      plano: "Plan",
      vendas: "Sales",
      conversao: "Conversion",
      comissao: "Commission",
      semVendas: "No sales in this period.",
      atalhos: "Quick shortcuts",
      proximoCompartilhamento: "Ready for your next share?",
      atalhosCopy: "Keep your main resources always at hand.",
      copiarMeuLink: "Copy my link",
      copiarMeuLinkCopy: "Share your unique code",
      materiais: "This week's materials",
      materiaisCopy: "See the new photos and pieces",
      suporte: "Contact support",
      suporteCopy: "We are here to help",
    },
    periodos: {
      1: "monthly",
      3: "quarterly",
      6: "semiannual",
      12: "annual",
    } as Record<number, string>,
    periodosTitulo: {
      1: "Monthly",
      3: "Quarterly",
      6: "Semiannual",
      12: "Annual",
    } as Record<number, string>,
    comissoes: {
      proxima: "Next commission",
      cicloAtual: "Current cycle",
      concluido: "{percentual}% complete",
      vendaElegivel: "1 eligible sale",
      vendasElegiveis: "{quantidade} eligible sales",
      verDetalhes: "See details",
      ultimosRepasses: "Latest payouts",
      historico: "Commission history",
      pago: "Paid",
      emAberto: "Open",
      verHistorico: "See full history",
      semComissoes: "No commissions yet.",
    },
    links: {
      eyebrow: "Activation",
      titulo: "My links",
      descricao: "Every link already carries your affiliate code. Just copy and share.",
      criar: "Create custom link",
      seuCodigo: "Your affiliate code: {codigo}",
      calloutCopy: "Use any link below to track the results of your promotion.",
      copiarCodigo: "Copy code",
      copiado: "Copied",
      modelosDisponiveis: "Available models",
      porModelo: "Links by model",
      buscar: "Search model",
      ensaioMakingOf: "Photo shoot + making of",
      ensaioExclusivo: "Exclusive photo shoot",
      ativo: "Active",
      copiar: "Copy",
      escolhaModelo: "Choose the model",
      selecioneModelo: "Select a model",
      linkUniversal: "Universal link",
      leveAssinantes: "Bring new subscribers to Bella Club.",
      bannerCopy: "Use your subscribe page to present all plans in one place.",
      copiarAssine: "Copy subscribe page link",
    },
    material: {
      eyebrow: "Promotion library",
      titulo: "Marketing materials",
      descricao: "Photos and videos, always without nudity, ready to promote Bella Club.",
      destaqueDaSemana: "Highlight of the week",
      novaBella: "{modelo} is our new model of the week.",
      destaqueCopy: "Download photos and short videos for your feed, stories and groups.",
      baixarPacote: "Download full pack",
      marca: "BELLA CLUB",
      editorial: "EDITORIAL",
      nota: "Safe content for promotion: photos and videos without nudity.",
      semana: "Week {numero}",
      tipos: {
        fotos_verticais: "Vertical photos",
        fotos_video: "Photos + video",
        fotos_feed: "Feed photos",
      } as Record<string, string>,
      fotos: "photos",
      foto: "photo",
      atualizadoOntem: "Updated yesterday",
      atualizadoHoje: "Updated today",
      acervo: "Bella archive",
      modeloAntiga: "Need material from an older model?",
      modeloAntigaCopy: "Request photos or videos of previous models from the site. The team checks the archive and sends the available pack for promotion.",
      escolhaModelo: "Choose the model",
      selecioneModelo: "Select a model",
      outraModelo: "Other model",
      digiteNome: "Type the model's name",
      nomeDaModelo: "Model's name",
      solicitar: "Request material",
      solicitacaoEnviada: "Request sent",
      baixarDe: "Download {modelo}'s pack",
      semMaterial: "No pack published yet. This week's materials will show up here.",
    },
    mensagens: {
      erro: "Error",
      fechar: "Close",
      muitasTentativas: "Too many attempts. Wait a minute and try again.",
      falhaAoCarregar: "We couldn't load the data. Please try again in a moment.",
    },
  },
};

export type TextosAreaAfiliado = typeof areaafiliado.portugues;

export default areaafiliado;
